import { render, staticRenderFns } from "./createCustomConsent.vue?vue&type=template&id=51b9c1c8&"
import script from "./createCustomConsent.vue?vue&type=script&lang=js&"
export * from "./createCustomConsent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports